module.exports = __webpack_public_path__ + "assets/c37746745b4216c577aeb458216a5da5.png";